import { styled } from 'styled-components'
import { Button as ButtonComponent } from '~/shared/ui/Buttons'

export const Button = styled(ButtonComponent)`
  font-weight: 700;
  justify-content: flex-start;
  box-shadow: 0 0 5px 0 #0015461a;
  display: flex;
  align-items: start;

  --border-style: none;
  --border-radius: 12px;

  > div {
    justify-content: flex-start;
    padding: 14px 18px;
  }
`
